import { render, staticRenderFns } from "./FacilityManager.vue?vue&type=template&id=318d0dbb&scoped=true"
import script from "./FacilityManager.vue?vue&type=script&lang=js"
export * from "./FacilityManager.vue?vue&type=script&lang=js"
import style0 from "./FacilityManager.vue?vue&type=style&index=0&id=318d0dbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318d0dbb",
  null
  
)

export default component.exports